export enum DynamicAction {
  'SplashNotificationMentionEvent' = 'SplashNotification::MentionEvent',
  'SplashNotificationAddCustomOption' = 'SplashNotification::AddCustomOption',
  'SplashNotificationEventDescription' = 'SplashNotification::EventDescription',
  'SplashNotificationTopTonightEvents' = 'SplashNotification::TopTonightEvents',
  'SplashNotificationTopWeekendEvents' = 'SplashNotification::TopWeekendEvents',
  'SplashNotificationUserEventComparison' = 'SplashNotification::UserEventComparison',
  'SplashNotificationUpcomingEventQuestion' = 'SplashNotification::UpcomingEventQuestion',
  'SplashNotificationRecapShow' = 'SplashNotification::RecapShow',
}

export interface DynamicActionProperties {
  to?: string;
  action?: string;
  payload?: Record<string, any>;
}

export type CtaIcon =
  | string
  | {
      faProps: {
        name: string;
      };
    };

interface CardListItem {
  startDate: string;
  title: string;
  description?: string;
  dots?: {
    completedCount: number;
    totalCount: number;
    text?: string;
  };
  cta: {
    variant?: 'outlined' | 'flat';
    text: string;
    startIcon?: CtaIcon;
    endIcon?: CtaIcon;
    to?: string;
    copyUrl?: string;
  };
}

interface PrimaryEngagementCard {
  title?: {
    text: string;
    cta?: {
      text: string;
      to: string;
    };
  };
  content?: {
    title: string;
    description: string;
  };
  listItems?: CardListItem[];
  primaryCta?: {
    startIcon?: CtaIcon;
    endIcon?: CtaIcon;
    text: string;
    to: string;
  };
  secondaryCta?: {
    startIcon?: CtaIcon;
    endIcon?: CtaIcon;
    text: string;
    to: string;
  };
}

interface PrimaryCard {
  title: string;
  messages: string[];
  metricMessage?: {
    faIcon: string;
    text: string;
    startIconAlign?: string;
    color: string;
    variant: string;
    ctaText: string;
  };
  chartData: ChartDatum[];
  actions: CardAction[];
}

interface ChartDatum {
  key: string;
  value: number;
  color: string;
}

interface CardAction extends DynamicActionProperties {
  iconUrl: string;
  label: string;
}

interface PrimaryTiles {
  title: string;
  weeklyMetrics: WeeklyMetric[];
}

interface WeeklyMetric extends DynamicActionProperties {
  count: number;
  title: string;
  indicatorCount: number;
  currentUserCount: number;
  ctaText: string;
  ctaTo: string;
  cta: DynamicActionProperties & { text: string };
}

interface SecondaryTiles {
  title: string;
  suggestedActions: SuggestedAction[];
}

interface SuggestedAction extends DynamicActionProperties {
  title: string;
  indicatorCount: number;
  imgUrl: string;
}

interface FeaturedFooterSection extends DynamicActionProperties {
  title: string;
  titleAfter?: string;
  imgUrl: string;
  count?: number;
}

interface FeaturedFooter {
  title: string;
  sections: FeaturedFooterSection[];
}

interface FeaturedPosters {
  tagId: string;
  tagSlug: string;
}

export interface AppDashboard {
  referralCard?: boolean;
  primaryEngagementCard?: PrimaryEngagementCard;
  primaryCard: PrimaryCard;
  primaryTiles: PrimaryTiles;
  secondaryTiles: SecondaryTiles;
  featuredFooter?: FeaturedFooter;
  featuredPosters?: FeaturedPosters;
  discoverScreenSections: FeaturedFooterSection[];
}
